import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import {Button, Col, Empty, Icon, message, Pagination, Row, Tag} from 'antd';
import {showMasterNotePreview} from '../../actions/master_notes_actions/PreviewMasterNoteActions';
import {get, post} from '../../components/mc_axios/McAxios';
import {Filters} from '../../components';
import {getLocalData, setLocalData} from '../../components/util';
import './MasterNotes.css';

class MasterNotesPre extends Component {
  constructor(props) {
    super(props);

    let lastVisitedPageNum = getLocalData('master-note-page-number', 1);
    lastVisitedPageNum =
        lastVisitedPageNum !== '' ? parseInt(lastVisitedPageNum) : 1;

    let itemsPerPage = getLocalData('master-note-items-per-page', 1);
    itemsPerPage = itemsPerPage !== '' ? parseInt(itemsPerPage) : 25;

    let masterNoteStatus = getLocalData('master-note-status', 1);
    masterNoteStatus = masterNoteStatus !== '' ? parseInt(masterNoteStatus) : 0;

    this.state = {
      masterNote: [],
      currentPageNumber: lastVisitedPageNum,
      itemsPerPage,
      totalItems: 0,
      paginationStart: 1,
      masterNoteStatus,
      masterNoteSearchTerm: getLocalData('master-note-search-term', 1),
    };
  }

  componentDidMount() {
    this.setState(
        state => ({
          paginationStart:
              state.currentPageNumber > 0
                  ? (state.currentPageNumber - 1) * state.itemsPerPage + 1
                  : 1,
        }),
        () => {
          this.getMasterNotesPreList();
        },
    );
  }

  getMasterNotesPreList = () => {
    const {
      itemsPerPage,
      currentPageNumber,
      masterNoteStatus,
      masterNoteSearchTerm,
    } = this.state;

    let data = {
      count: itemsPerPage,
      page_number: currentPageNumber,
      subject: '',
      status: parseInt(masterNoteStatus),
      search_term: masterNoteSearchTerm,
    };

    post('/api/master-notes/master-notes', data).then(response => {
      if (response.data.status === true) {
        let resData = response.data.data;
        this.setState({
          totalItems: resData.count,
          masterNote: resData.master_notes,
        });
      }
    });
  };

  handleItemsCount = value => {
    setLocalData('master-note-items-per-page', value, 1);
    this.setState(
        {
          currentPageNumber: 1,
          paginationStart: 1,
          itemsPerPage: value,
        },
        () => {
          this.getMasterNotesPreList();
        },
    );
  };

  handleStatusChange = value => {
    setLocalData('master-note-status', value, 1);
    this.setState(
        {
          currentPageNumber: 1,
          paginationStart: 1,
          masterNoteStatus: value,
        },
        () => {
          this.getMasterNotesPreList();
        },
    );
  };

  handleSearchTermChange = e => {
    let value = e.target.value;
    setLocalData('master-note-search-term', value, 1);
    this.setState({
      masterNoteSearchTerm: value,
    });
  };

  handleSearchTermSubmit = () => {
    this.getMasterNotesPreList();
  };

  onPageChange = pageNumber => {
    let actualPage = Math.max(0, pageNumber - 1);
    let start = actualPage * this.state.itemsPerPage;
    setLocalData('master-note-page-number', pageNumber, 1);
    this.setState(
        {
          currentPageNumber: pageNumber,
          paginationStart: start + 1,
        },
        () => {
          this.getMasterNotesPreList();
        },
    );
  };

  resetFilters = () => {
    this.setState(
        {
          currentPageNumber: 1,
          paginationStart: 1,
          itemsPerPage: 25,
          masterNoteStatus: 0,
          masterNoteSearchTerm: '',
        },
        () => {
          setLocalData('master-note-items-per-page', 25, 1);
          setLocalData('master-note-page-number', 1, 1);
          setLocalData('master-note-status', 0, 1);
          setLocalData('master-note-search-term', '', 1);
          this.getMasterNotesPreList();
        },
    );
  };

  getNoteData = noteId => {
    if (noteId !== undefined) {
      get(`/api/notes/notes/${noteId}`).then(response => {
        if (response.data.status === true) {
          let noteData = response.data.data.note;
          this.setState({
            noteContent: noteData.explanation,
          });
        } else {
          this.setState({
            noteContent: '',
          });
          message.error('Something went wrong. Try again.');
        }
      });
    }
  };

  redirectToEditPage = id => {
    this.props.history.push(`/dashboard/master-notes/edit/${id}`);
  };

  render() {
    const {
      masterNote,
      currentPageNumber,
      itemsPerPage,
      masterNoteStatus,
      masterNoteSearchTerm,
      totalItems,
      paginationStart,
    } = this.state;

    const {showMasterNotePreview} = this.props;

    return (
        <>
          <div className="secondary-header">
            <Row>
              <Col span={6} className="secondary-header-left">
                <p>Master Notes</p>
              </Col>
              <Col span={18} className="secondary-header-right">
                <Button type="primary" className="mc-mr-10" htmlType="button">
                  <Link to={'/dashboard/master-notes/create'}>
                    Add Master Note
                  </Link>
                </Button>
                <Button htmlType="button" type="dashed">
                  <Link to={'/dashboard/master-notes/trash'}>Trash</Link>
                </Button>
              </Col>
            </Row>
          </div>
          <div className="main-content-block">
            <Filters
                countValue={itemsPerPage}
                onItemsCountChange={this.handleItemsCount}
                statusValue={masterNoteStatus}
                onStatusChange={this.handleStatusChange}
                searchTermValue={masterNoteSearchTerm}
                onSearchTermChange={this.handleSearchTermChange}
                onSearchTermSubmit={this.handleSearchTermSubmit}
                onFiltersReset={this.resetFilters}
            />
            {masterNote !== undefined && masterNote.length > 0 ? (
                <Row className="mc-mt-10">
                  <Col xs={24}>
                    <div className="mc-table-responsive">
                      <table className="mc-table notes-table">
                        <thead>
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Updated At</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {masterNote.map((masterNote, index) => (
                            <tr key={masterNote.master_note_id}>
                              <td>{paginationStart + index}</td>
                              <td
                                  onClick={() =>
                                      this.redirectToEditPage(
                                          masterNote.master_note_id)
                                  }
                              >
                                {masterNote.master_title}
                              </td>
                              <td>
                                {moment.unix(masterNote.updated_at).
                                    format('DD/MM/YYYY')}
                              </td>
                              <td>
                                {masterNote.status === 2 ? (
                                    <Tag color="#28a745">Verified</Tag>
                                ) : (
                                    <Tag color="#17a2b8">Draft</Tag>
                                )}
                              </td>
                              <td className="actions-icons">
                                <Icon
                                    type="eye"
                                    style={{
                                      fontSize: 24,
                                      marginRight: 5,
                                      marginLeft: 5,
                                      verticalAlign: 'center',
                                    }}
                                    title="Preview"
                                    onClick={() =>
                                        showMasterNotePreview(
                                            `${masterNote.master_note_id}`,
                                        )
                                    }
                                />
                              </td>
                            </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                        className="mc-mt-15"
                        current={currentPageNumber}
                        pageSize={itemsPerPage}
                        total={totalItems}
                        onChange={this.onPageChange}
                    />
                  </Col>
                </Row>
            ) : (
                <Empty
                    className="mc-mtb-100"
                    image="https://s3.ap-south-1.amazonaws.com/copy-medcampus/wp-content/uploads/2019/03/06191929/no-data.png"
                    description={<span>No notes found</span>}
                />
            )}
          </div>
        </>
    );
  }
}

const MasterNotes = connect(
    null,
    {showMasterNotePreview},
)(MasterNotesPre);

export {MasterNotes};
